<template lang="pug">
  v-container.View.View--CompanyInfo
    v-stepper(v-model='registrationStep')
      v-stepper-header
        v-stepper-step(:complete="registrationStep > 1" step="1") Partita IVA
        v-divider
        v-stepper-step(:complete="registrationStep > 2" step="2") Dati Personali
        v-divider
        v-stepper-step(:complete="registrationStep > 3" step="3") Dati Azienda
        v-divider
        v-stepper-step(:complete="registrationStep > 4" step="4") Riepilogo
      v-stepper-items
        v-stepper-content(step="1")
          .headline Partita IVA
          .subtitle-1 Inserisci la tua partita IVA per iniziare la procedura di registrazione. Il servizio è completamente gratuito per i primi 30 giorni!
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-row(no-gutters)
                v-col(cols="12")
                  ValidationProvider(name="Partita Iva" rules="required|min:11|max:16" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.company.vat" required
                      name="partita iva" type="number"
                      :error-messages="errors"
                      label="Partita Iva" prepend-inner-icon="mdi-numeric"
                    )
                v-col(cols="12")
                  div(id="recaptcha-register")

            .d-flex.my-3.align-end
              v-spacer
              v-btn.primary(
                :loading="loadingStep"
                @click="passes(checkVatAndContinue)"
                :disabled='invalid || !validated'
              ) Continua
        v-stepper-content(step="2")
          .headline Dati Personali
          .subtitle-1 Inserisci qui i tuoi dati
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-row(no-gutters)
                v-col(cols="12")
                  ValidationProvider(name="Nome" rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.personal.name" required
                      name="nome" type="text"
                      :error-messages="errors"
                      label="Nome" prepend-inner-icon="mdi-account"
                    )
                v-col(cols="12")
                  ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.personal.surname" required
                      name="cognome" type="text"
                      :error-messages="errors"
                      label="Cognome" prepend-inner-icon="mdi-account"
                    )
                v-col(cols="12")
                  ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.personal.email" required
                      name="e-mail" type="email"
                      :error-messages="errors"
                      label="Email" prepend-inner-icon="mdi-at"
                    )
                v-col(cols="12")
                  ValidationProvider(name="Telefono Personale" rules="required|min:9" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.personal.phone" required
                      name="telefono" type="text"
                      :error-messages="errors"
                      label="Telefono Personale" prepend-inner-icon="mdi-phone"
                    )
                v-col(cols="12")
                  ValidationProvider(name="Password" rules="required|min:6" v-slot="{ errors }" vid="password")
                    v-text-field(
                      v-model="form.personal.password" required
                      name="password" type="password"
                      :error-messages="errors"
                      label="Password" prepend-inner-icon="mdi-asterisk"
                    )
                v-col(cols="12")
                  ValidationProvider(name="Conferma Password" rules="required|min:6|confirmed:password" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.personal.password_confirm" required
                      name="conferma password" type="password"
                      :error-messages="errors"
                      label="Conferma Password" prepend-inner-icon="mdi-asterisk"
                    )
            .d-flex.my-3.align-end
              v-btn(@click="registrationStep=1" small text outlined) Indietro
              v-spacer
              v-btn.primary(
                @click="passes(() => registrationStep=3)"
                :disabled='invalid'
              ) Continua
        v-stepper-content(step="3")
          .headline Dati Azienda
          .subtitle-1 Inserisci qui i dati della tua azienda
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-row(no-gutters)
                v-col(cols="12")
                  ValidationProvider(name="Ragione Sociale" rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.company.name" required
                      name="ragione sociale" type="text"
                      :error-messages="errors"
                      label="Ragione Sociale" prepend-inner-icon="mdi-sign-text"
                      :readonly="form.company.id != null"
                      :disabled="form.company.id != null"
                    )
                template(v-if="!form.company.id")
                  v-col(cols="12")
                    ValidationProvider(name="Partita Iva" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.vat" required
                        name="partita iva" type="text"
                        :error-messages="errors"
                        label="Partita Iva" prepend-inner-icon="mdi-numeric"
                      )
                  v-col(cols="12")
                    ValidationProvider(name="Codice Fiscale" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.taxCode" required
                        name="codice fiscale" type="text"
                        :error-messages="errors"
                        label="Codice Fiscale" prepend-inner-icon="mdi-numeric"
                      )
                  v-col(cols="12")
                    .subtitle-2 Sede Legale
                  v-col(cols="12")
                    ValidationProvider(name="Indirizzo" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.address" required
                        name="indirizzo" type="text"
                        :error-messages="errors"
                        label="Indirizzo" prepend-inner-icon="mdi-map-marker"
                      )
                  v-col(cols="12")
                    ValidationProvider(name="Citta'" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.city" required
                        name="citta'" type="text"
                        :error-messages="errors"
                        label="Citta'" prepend-inner-icon="mdi-map-marker"
                      )
                  v-col(cols="6")
                    ValidationProvider(name="CAP" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.zipCode" required
                        name="cap" type="text"
                        :error-messages="errors"
                        label="CAP" prepend-inner-icon="mdi-map-marker"
                      )
                  v-col.pl-3(cols="6")
                    ValidationProvider(name="Provincia" rules="required|min:2|max:2" v-slot="{ errors }")
                      v-text-field(
                        v-model="form.company.province" required
                        name="provincia" type="text"
                        :error-messages="errors"
                        label="Provincia" prepend-inner-icon="mdi-map-marker"
                      )
                template(v-if="form.company.id")
                  v-alert(type="info" outlined) Sei gia' cliente iPratico, i tuoi dati saranno inseriti in automatico
            .d-flex.my-3.align-end
              v-btn(@click="registrationStep=2" small text outlined) Indietro
              v-spacer
              v-btn.primary(
                @click="passes(() => registrationStep=4)"
                :disabled='invalid'
              ) Continua
        v-stepper-content(step="4")
          .headline Riepilogo Dati
          .subtitle-1 Assicurati che sia tutto corretto
          .pa-3
            .subtitle-2 Dati Personali
            div
              b Nome e Cognome:
              span {{ form.personal.name }} {{ form.personal.surname }}
            div
              b Email:
              span {{ form.personal.email }}
            div
              b Telefono:
              span {{ form.personal.phone }}
            .subtitle-2.mt-3 Dati Azienda
            div
              b Ragione Sociale:
              span {{ form.company.name }}
            div
              b Partita IVA:
              span {{ form.company.vat }}
            div
              b Codice Fiscale:
              span {{ form.company.taxCode }}
            div
              b Indirizzo:
              span {{ form.company.address }}, {{ form.company.city }}, {{ form.company.zipCode }}, {{ form.company.province }}
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-row(no-gutters)
                v-col(cols="12")
                  ValidationProvider(name="Privacy" rules="required" v-slot="{ errors }")
                    v-checkbox(
                      v-model="form.privacy" required
                      :error-messages="errors"
                      name="privacy"
                      :true-value="true"
                      :false-value="null"
                    )
                      template(slot="label")
                        span Acconsento al trattamento dei miei dati secondo la&nbsp;
                          a(href="https://www.ipraticocloud.com/files/shares/informativa_privacy_clienti.pdf" target="_blank" @click.stop) politica privacy
                v-col(cols="12")
                  div(id="recaptcha-register-2")
            .d-flex.my-3.align-end
              v-btn(@click="registrationStep=3" small text outlined) Indietro
              v-spacer
              v-btn.success(
                @click="passes(register)" :disabled='invalid || !validated'
              ) Registrati
        v-stepper-content(step="5")
          .text-center
            .headline Registrazione effettuata
            v-icon.mb-3(size="8rem" color="success") mdi-checkbox-marked-circle
            div Riceverai a breve una <b>mail</b> per <b>confermare il tuo account</b> ed iniziare ad usarlo.
            .headline Grazie!
            .mt-3 Se non trovi la mail, controlla anche nella cartella dello spam.

    HelpAlert.mt-3

</template>

<script>
import HelpAlert from "@/components/HelpAlert";
import Merchant from "@/api/Merchant";
import ErrorMessage from "@/utils/ErrorMessage";

export default {
  name: "CompanyRegister",
  components: { HelpAlert },
  watch: {
    registrationStep: function(step) {
      window.scrollTo(0, 0);
      if (step == 1) window.grecaptcha.reset(this.recaptchaWidget);
      if (step == 4) window.grecaptcha.reset(this.recaptchaWidget2);
    }
  },
  data() {
    return {
      loadingStep: false,
      registrationStep: 1,

      form: {
        personal: {},
        company: {}
      },

      recaptchaWidget: null,
      recaptchaWidget2: null,
      recaptchaToken: null
    };
  },

  mounted() {
    this.$emit("update:title", "Registra la tua azienda");
    this.$nextTick(() => {
      setTimeout(() => {
        this.recaptchaWidget = window.renderRecaptcha("recaptcha-register");
        this.recaptchaWidget2 = window.renderRecaptcha("recaptcha-register-2");
      }, 500);
    });
  },

  methods: {
    async checkVatAndContinue() {
      if (!window.grecaptcha.getResponse(this.recaptchaWidget))
        throw new ErrorMessage("Completa il CAPTCHA");

      this.loadingStep = true;
      let response;
      try {
        response = await Merchant.checkVat({
          vat: this.form.company.vat,
          "g-recaptcha-response": window.grecaptcha.getResponse(
            this.recaptchaWidget
          )
        });
      } catch (error) {
        if (error.response.status !== 302) {
          throw error;
        }
        response = error.response.data;
      } finally {
        window.grecaptcha.reset();
        this.loadingStep = false;
      }

      if (response && response.code === 302) {
        // already existing
        const formCompany = {
          id: response.company.id,
          vat: response.company.vat,
          taxCode: response.company.taxCode,
          name: response.company.name,
          address: response.company.address,
          city: response.company.city,
          zipCode: response.company.zipCode,
          province: response.company.province,
          nation: response.company.nation
        };
        this.$set(this.form, "company", formCompany);
      }

      this.loadingStep = false;
      this.registrationStep = 2;
    },

    async register() {
      if (!window.grecaptcha.getResponse(this.recaptchaWidget2))
        throw new ErrorMessage("Completa il CAPTCHA");
      this.loadingStep = true;
      try {
        await Merchant.register({
          ...this.form.personal,
          company: { ...this.form.company, nation: "IT" },
          privacy: this.form.privacy,
          "g-recaptcha-response": window.grecaptcha.getResponse(
            this.recaptchaWidget2
          )
        });
      } finally {
        this.loadingStep = false;
      }
      this.registrationStep = 5;
    },

    goBack() {
      if (this.registrationStep > 1) {
        this.registrationStep -= 1;
      } else {
        window.history.length > 0
          ? this.$router.go(-1)
          : this.$router.push({ name: "home" });
      }
    }
  }
};
</script>
